import _ from 'lodash'
import getAttributes from '../store/attributes'
import common from '../settings/common.localization.json'

// This function takes in a json object that looks like:
// {
//     "en": {
//         "tooltipText": "EVE Time (UTC)"
//     },
//     "fr": {
//         "tooltipText": "Heure d'EVE (UTC)"
//     },
//     "ru": {
//         "tooltipText": "Время EVE Online (UTC)"
//     }
// }
// It goes through the list and returns a new object that
// has filled in the missing languages with the default language
// and added all the common properties from /settings/common.localization.json
// Given the input above the result would be:
// {
//     en: {
//         tooltipText: 'EVE Time (UTC)',
//         attention: 'Attention',
//         error: 'Error',
//         warning: 'Warning',
//         externalLink: 'Open External Link',
//     },
//     de: {
//         tooltipText: 'EVE Time (UTC)',
//         attention: 'Achtung',
//         error: 'Fehler',
//         warning: 'Warnung',
//         externalLink: 'Externe Links öffnen',
//     },
//     fr: {
//         tooltipText: 'Heure d\'EVE (UTC)',
//         attention: 'Attention',
//         error: 'Erreur',
//         warning: 'Avertissement',
//         externalLink: 'Ouvrir le lien externe',
//     },
//     ru: {
//         tooltipText: 'Время EVE Online (UTC)',
//         attention: 'Внимание',
//         error: 'Ошибка',
//         warning: 'Предупреждение',
//         externalLink: 'Переход по внешней ссылке',
//     },
// }
// Notice how the tooltipText that was missing from de in the input
// has been added to the result with the english text instead
const getTexts = (strings) => {
    let fallbackLocale = null
    // todo: attribs! take into account the locale
    //       We could take in the locale and use it to return an entirely different result
    //       in the chinese version and in that case skip the entire reduce loop in the beginning
    const attributes = getAttributes()
    // We go through the list of languages defined in /settings/attributes
    const locales = _.reduce(
        attributes.languages,
        (result, ignoredValue, locale) => {
            // We assume the first language in the list is the fallback language
            // We also assume that no properties are missing from the fallback language
            if (fallbackLocale == null) {
                fallbackLocale = { ...common[locale], ...strings[locale] }
            }
            result[locale] = { ...fallbackLocale, ...common[locale], ...strings[locale] }
            return result
        },
        {},
    )

    // If we have anything, then add the chinese language as well
    if (fallbackLocale) {
        // First create an object with empty properties (since we don't want to fallback to English)
        let chinese = _.reduce(
            fallbackLocale,
            (result, value, property) => {
                result[property] = ''
                return result
            },
            {},
        )

        if (process.env.NODE_ENV === 'development') {
            // For testing purposes we want to fallback to English...:
            chinese = { ...fallbackLocale }
            console.info(
                'We are currently fallbacking chinese to English, in the final release we only want to fallback to an empty string, so please remove the above line',
            )
        }

        // If we have any chinese in the common file, add that
        if (common.zh) {
            chinese = { ...chinese, ...common.zh }
        }

        // If we have any chinese in the input, add that
        if (strings.zh) {
            chinese = { ...chinese, ...strings.zh }
        }

        // Finally add chinese to the result
        locales.zh = chinese
    }

    return locales
}

export default getTexts



// WEBPACK FOOTER //
// ./src/store/localizer.js